import { InfoCircleOutlined } from '@ant-design/icons';
import { Badge, Space, Tooltip } from 'antd';
import {
  DonationProductOutput,
  ProductStatus,
  ReasonDiscardProduct,
} from 'gql/types';
import { getProductStatusDotColor } from 'modules/products/utils/getProductStatusDotColor';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { downcaseFirstLetter } from 'utils/downcaseFirstLetter';

type PropTypes = {
  donationProduct: DonationProductOutput;
};

const DonationProductStatusBadge: FC<PropTypes> = ({ donationProduct }) => {
  const { t } = useTranslation('products.DonationProductDiscardedReasons');

  const getDiscardReasonLabel = (reason: ReasonDiscardProduct) => {
    const key = ReasonDiscardProduct[reason];
    return `${t('reason')}: ${t(downcaseFirstLetter(key))}`;
  };

  const isDonationDiscarded =
    donationProduct.status === ProductStatus.Discarded;
  const discardedReason =
    donationProduct.discardedProduct?.reason ?? ReasonDiscardProduct.Other;

  const statusDotColor = getProductStatusDotColor(donationProduct.status);
  return (
    <Space size={4}>
      <Badge color={statusDotColor} text={donationProduct.status} />
      {isDonationDiscarded && (
        <Tooltip title={getDiscardReasonLabel(discardedReason)}>
          <InfoCircleOutlined />
        </Tooltip>
      )}
    </Space>
  );
};

export default DonationProductStatusBadge;
